import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate environment is selected
  if (!properties.environment) {
    errors.push({
      key: 'environment',
      message: 'Environment is required',
    });
  }

  // Validate action is selected
  if (!properties.action) {
    errors.push({
      key: 'action',
      message: 'Action is required',
    });
  }

  // Validate query params format if provided
  if (properties.queryParams && typeof properties.queryParams === 'string') {
    const queryString = properties.queryParams.trim();
    if (queryString.length > 0) {
      // Basic validation: check for key=value format
      const params = queryString.split('&');
      for (const param of params) {
        if (!param.includes('=')) {
          errors.push({
            key: 'queryParams',
            message: 'Query parameters must be in format: key=value or key1=value1&key2=value2',
          });
          break;
        }
      }
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
